import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useAppSelector } from "../../hooks/redux";
import PledgeUnpledgePopup from "../margin/pledgeUnpledgePopup";
const PledgeUnpledge = () => {
    const isPledgeUnPldge = useAppSelector((state) => {
        return state.modals.pledgeunpledgeModal;
    });
    return (_jsx(_Fragment, { children: isPledgeUnPldge && (_jsx(React.Suspense, Object.assign({ fallback: _jsx(_Fragment, {}) }, { children: _jsx(PledgeUnpledgePopup, {}) }))) }));
};
export default PledgeUnpledge;
